//@ts-check
import queryString from 'query-string';
/**
 * @type {import("./types").getSearchParamsType}
 */

export default function getSearchParams(location) {
  if (typeof location === 'undefined') location = window.location;
  if (!location) return {};

  if (typeof location === 'string') {
    if (location.startsWith('http') && location.indexOf('://') > -1) location = queryString.extract(location);
    return queryString.parse(location);
  }

  if (!location.search) return {};
  return queryString.parse(location.search);
}